import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CartActions } from '@spartacus/cart/base/core';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';
import { ScheduledReplenishmentOrderConnector } from '@spartacus/order/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { CustomCheckoutActions } from '../actions';

@Injectable()
export class ReplenishmentOrderEffects {
  protected logger = inject(LoggerService);
  scheduleReplenishmentOrder$: Observable<CustomCheckoutActions.ScheduleReplenishmentOrderSuccess | CustomCheckoutActions.ScheduleReplenishmentOrderFail | CartActions.RemoveCart> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(CustomCheckoutActions.SCHEDULE_REPLENISHMENT_ORDER),
        map((action: CustomCheckoutActions.ScheduleReplenishmentOrder) => action.payload),
        mergeMap((payload) => {
          return this.scheduledReplenishmentOrderConnector.scheduleReplenishmentOrder(payload.cartId, payload.scheduleReplenishmentForm, payload.termsChecked, payload.userId).pipe(
            switchMap((data) => [new CartActions.RemoveCart({ cartId: payload.cartId }), new CustomCheckoutActions.ScheduleReplenishmentOrderSuccess(data)]),
            catchError((error) => of(new CustomCheckoutActions.ScheduleReplenishmentOrderFail(tryNormalizeHttpError(error, this.logger))))
          );
        })
      )
    );

  constructor(private actions$: Actions, private scheduledReplenishmentOrderConnector: ScheduledReplenishmentOrderConnector) {}
}
